import React, { Dispatch, FC, SetStateAction } from 'react'
import { FiltersPanel, FiltersPanelType } from 'components/SA/Filters'
import styles from './FiltersAndArtworksGrid.module.scss'
import Skeleton from 'components/SA/Skeleton'

type PolaroidSideFiltersProps = {
  filters: ReadonlyArray<FiltersPanelType>
  isFiltersLoading?: boolean
  baseUrl: string
  nextAppRoute: string
  setIsFiltersVisible: Dispatch<SetStateAction<boolean>>
  closeModal?: () => void
  customClearFilterCallback?: () => void
  customShowResultsCallback?: () => void
  filteredResultsCount?: number
}

export const FiltersSkeleton = () => {
  return (
    <div className={styles.filtersSkeletonBox}>
      <Skeleton width='100%' height='40px' />
      <div className={styles.filtersSkeletonInfo}>
        <Skeleton width='80%' height='24px' />
        <Skeleton width='80%' height='24px' />
        <Skeleton width='80%' height='24px' />
      </div>
    </div>
  )
}

const PolaroidSideFilters: FC<PolaroidSideFiltersProps> = ({
  filters,
  isFiltersLoading,
  baseUrl,
  nextAppRoute,
  setIsFiltersVisible,
  closeModal,
  customClearFilterCallback,
  customShowResultsCallback,
  filteredResultsCount,
}) => {
  if (isFiltersLoading) {
    return (
      <div className={styles.filtersSkeletonContainer}>
        {Array.from({ length: 6 }, (_, index) => (
          <FiltersSkeleton key={index.toString()} />
        ))}
      </div>
    )
  }

  return (
    <FiltersPanel
      filters={filters}
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
      setIsFiltersVisible={setIsFiltersVisible}
      closeModal={closeModal}
      totalFiltered={filteredResultsCount}
      customClearFilterCallback={customClearFilterCallback}
      customShowResultsCallback={customShowResultsCallback}
    />
  )
}

export default PolaroidSideFilters
